import type { CapacityStoreState } from '../reducers/capacity.reducer';
import type { SharedStoreState } from '../types/store';

export function selectCapacityStore(
	state: SharedStoreState,
): CapacityStoreState {
	return state.capacity;
}
